(() => {
  const attr = $(".smart-lock-bundle-addon").attr("data-reverse_title");
  const isReverse = typeof attr !== "undefined" && attr !== false;

  const normalizeGateModel = (model, feature) => {
  const ultra = feature === "Ultra";

  switch (model) {
    case "For Regular Gates":
      return ultra ? "Sentry Ultra Gate Lock" : "Sentry Gate Lock";

    case "For Glass/Privacy Gates":
      return ultra
        ? "Sentry Ultra Privacy Gate Lock"
        : "Sentry Privacy Gate Lock";

    default:
      return model;
  }
  };

  $(".smart-lock-bundle-addon .addon-box").on("click", function () {
    $(".smart-lock-bundle-addon [name='bundle-addon']").click();
  });

  $(".smart-lock-bundle-addon [name='bundle-addon']").on("click", function () {
    $(".smart-lock-bundle-addon").toggleClass("checked");

    if (!$(this).is(":checked")) {
      updateBundleAddon({ unselect: true });
      return;
    }

    updateBundleAddon({ skip: true });
  });

  $(".smart-lock-bundle-addon [name='addon-product']").on(
    "click",
    function (e) {
      e.stopPropagation();
    },
  );

  $(".smart-lock-bundle-addon [name='addon-product']").on(
    "change",
    function () {
      $(".smart-lock-bundle-addon .prod-options").addClass("hide");
      $(
        `.smart-lock-bundle-addon .prod-options[data-product='${this.value}']`,
      ).removeClass("hide");

      updateAddonVariant();
    },
  );

  $(".smart-lock-bundle-addon .addon-product .item").on("click", function (e) {
    e.stopPropagation();

    $(this).siblings(".item").removeClass("active");
    $(this).addClass("active");

    $(this)
      .closest(".sel-wrapper")
      .prev()
      .find(".sel")
      .text($(this).attr("data-sel-text") ?? $(this).attr("data-option"));

    $(".smart-lock-bundle-addon .prod-options").addClass("hide");
    $(
      `.smart-lock-bundle-addon .prod-options[data-product='${$(this).attr("data-product-id")}']`,
    ).removeClass("hide");

    updateAddonVariant();
  });

  $(".smart-lock-bundle-addon .prod-options .item").on("click", function (e) {
    e.stopPropagation();

    $(this).siblings(".item").removeClass("active");
    $(this).addClass("active");

    $(this)
      .closest(".sel-wrapper")
      .prev()
      .find(".sel")
      .text($(this).attr("data-sel-text") ?? $(this).attr("data-option"));

    updateAddonVariant();
  });

  const updateAddonVariant = () => {
    const options = $(
      ".smart-lock-bundle-addon .prod-options:not(.hide) .item.active",
    )
      .map((_, el) => $(el).attr("data-option"))
      .get();

    const select = $(".smart-lock-bundle-addon [name='addon-variant']");
    select.val(select.find(`[data-option='${options.join(" / ")}']`).val());
    select.trigger("change");
  };

  const updateAddonPrice = () => {
    const mainPrice =
      Number(
        $("[name='variant_id']")
          .find(`option[value='${$("[name='variant_id']").val()}']`)
          .attr("data-price")
          .replace(",", "")
      ) * 100 || 0;

    const mainOption = $(
      ".product-form-standardSelector .item.active, .product-form-sentrySelector .option-wrapper:not(.hide) .item.active"
    )
      .map((_, el) => $(el).attr("data-option"))
      .get();

    const addonOption = $(
      ".smart-lock-bundle-addon .prod-options:not(.hide) .item.active"
    )
      .map((_, el) => $(el).attr("data-option"))
      .get();

    addonOption[0] = normalizeGateModel(addonOption[0], addonOption[1]);

    const option = !isReverse
      ? mainOption.join(" / ") + " / " + addonOption.join(" / ")
      : addonOption.join(" / ") + " / " + mainOption.join(" / ");

      //console.log("Searching:", option);

$(".smart-lock-bundle-addon [name='bundle-variant'] option").each(function () {
  //console.log($(this).attr("data-option"));
});

    const selectedOption = $(".smart-lock-bundle-addon [name='bundle-variant']")
      .find(`[data-option="${option}"]`);

    //console.log("Matched Variant ID:", selectedOption.val());
//console.log("Matched Title:", selectedOption.attr("data-option"));
//console.log("Matched Price:", selectedOption.attr("data-price"));
//console.log("Main Variant ID:", $("[name='variant_id']").val());
//console.log("Main Price:", mainPrice);

    if (!selectedOption.length) {
      console.warn("Bundle price not found:", option);
      return;
    }

    const bundleAddonPrice = Number(selectedOption.attr("data-price"));

    $(".smart-lock-bundle-addon .price-wrapper .price").text(
      theme.Currency.formatMoney(bundleAddonPrice - mainPrice)
    );

    //console.log("Main Price:", mainPrice);
//console.log("Bundle Price:", selectedOption.attr("data-price"));
  };

  const updateAddonImage = () => {
    const select = $(".smart-lock-bundle-addon [name='addon-variant']");
    const selectedOption = select.find(`option[value='${select.val()}']`);

    $(".smart-lock-bundle-addon .img-wrapper img").attr(
      "src",
      selectedOption.attr("data-image"),
    );
  };

  const updateBundleAddon = (
    { skip, unselect } = { skip: false, unselect: false },
  ) => {
    const mainOption = $(".product-form-standardSelector .item.active, .product-form-sentrySelector .option-wrapper:not(.hide) .item.active")
      .map((_, el) => $(el).attr("data-option"))
      .get();
    const addonOption = $(
      ".smart-lock-bundle-addon .prod-options:not(.hide) .item.active",
    )
      .map((_, el) => $(el).attr("data-option"))
      .get();

    addonOption[0] = normalizeGateModel(addonOption[0], addonOption[1]);

    const option = !isReverse
      ? mainOption.join(" / ") + " / " + addonOption.join(" / ")
      : addonOption.join(" / ") + " / " + mainOption.join(" / ");

    const select = $(".smart-lock-bundle-addon [name='bundle-variant']");

    if (unselect) {
      select.val("");
    } else if (select.val() || skip) {
      select.val(select.find(`[data-option='${option}']`).val());
    } else {
      return;
    }

    select.trigger("change");
  };

  const updateATCbuttons = (bundleVariantId) => {
    const atcButton = $("#AddToCart-button");
    const checkoutBtn = $("#initateCheckout");
    const soldOutBtn = $("#sold-out-btn");

    const selOption = $(
      `.smart-lock-bundle-addon [name='bundle-variant'] option[value='${bundleVariantId}']`,
    );

    if (selOption.attr("data-available") == "true") {
      atcButton.show();
      checkoutBtn.show();
      soldOutBtn.addClass("hide");
    } else {
      atcButton.hide();
      checkoutBtn.hide();
      soldOutBtn.removeClass("hide");
    }
  };

  const updateLeadTime = () => {
  const activeProdOptions = $(".smart-lock-bundle-addon .prod-options:not(.hide)");

  const model = $(".select-model .sel").text().trim();

  const feature = activeProdOptions
    .find(".wrapper-select-features .sel")
    .text()
    .trim();

  const colour = activeProdOptions
    .find(".wrapper-select-colour .sel")
    .text()
    .trim();

  const currentHandle = window.location.pathname;

  let showLeadTime = false;

  // Sentry PDP
  if (currentHandle.includes("prism-sentry-series-2026")) {
    showLeadTime =
      (model === "Sentinel" &&
        feature === "Ultra" &&
        (colour === "Onyx Black" || colour === "Copper Rose")) ||
      (model === "Spectre" &&
        feature === "Ultra" &&
        colour === "Onyx Black");
  }

  // Spectre + Sentinel PDP
  /*
  if (
    currentHandle.includes("prism-spectre-series-2026") ||
    currentHandle.includes("prism-sentinel-series-2026")
  ) {
    showLeadTime =
      model === "For Regular Gates" &&
      feature === "Standard" &&
      colour === "Onyx Black";
  }
  */

  $(".smart-lock-bundle-addon .lead-time").toggleClass(
    "hide",
    !showLeadTime,
    );
  };

$(".smart-lock-bundle-addon [name='addon-variant']").on(
  "change",
  function () {
    updateAddonPrice();
    updateAddonImage();
    updateBundleAddon();
    updateLeadTime();
  },
);

  $("[name='variant_id']").on("change", function () {
    updateBundleAddon();
    updateAddonPrice();
  });

  $(".smart-lock-bundle-addon [name='bundle-variant']").on(
    "change",
    function () {
      const value = this.value;

      if (value) {
        $("#currentSelection").attr("data-variant", value);
        updateLinks();
        updateATCbuttons(value); // run only when bundle variant is selected
      } else {
        // trigger onchange for main product
        $("[name='variant_id']").trigger("change");
        return;
      }
    },
  );

  const moveBundleVariantsToMainSelect = () => {
    // move the bundle variants to main select so that the bundled products will be auto added to cart in `bundle.js`
    const select = $("#ProductSelect-product-template");
    if (!select.length) return;

    select.append(
      $(".smart-lock-bundle-addon [name='bundle-variant'] option").clone(),
    );
  };

  
  

  updateAddonPrice();
  updateLeadTime();
  moveBundleVariantsToMainSelect();
})();
